import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button, Alert} from "react-bootstrap";

import api from "../../services/api";
import "./styles.css";

export default function ParticipanteEsqueciSenha({ history }) {
    const [pessoa, setPessoa] = useState([]);
    const [email, setEmail]= useState('');
    const { consulta_id } = useParams();
    const [idAudiencia] = useState(consulta_id);
    const [mensagem, setMensagem]= useState("");
    const [tipoMensagem, setTipoMensagem] = useState("danger");
    const [avisoEmail, setAvisoEmail] = useState(false);
 
    useEffect(() => {
      async function loadPessoa() {
        if (email && email.indexOf("@")>2) {
          const response = await api.get(`/api/pessoa/${email}/publico`);
          setPessoa(response.data[0]);
        }
      }
      loadPessoa();
    }, [email]);

    function handleCancelar() {
      if (idAudiencia>0){
        history.push(`/Consulta/${idAudiencia}`);
      } else {
        history.push(`/`);
      }
    }

    function handleAEnviarNovo() {
      if (criticaEmail()){
        salvaNovoToken();
      }
    }

    function criticaEmail() {
      setMensagem([]);
      var msg = "Erro: ";
      if (!email || email.length < 4){
        msg +="E-mail é obrigatório; "
      } else {
          if (email.indexOf("@")<1) {
            msg +="E-mail é inválido; "
          }
      }
      if (msg.length > 6){
        setMensagem(msg);
        setTipoMensagem("danger");
        return false;  
      }
      else {
        return true;
      }
    }
    async function salvaNovoToken() {
      const data = { 
        'idPessoa': pessoa.ID_PESSOA
      };
      const response = await api.post(
        `/api/token`,
        data);
      enviaEmailConfirmacao(response.data[0].idToken);
    }
    async function enviaEmailConfirmacao(idToken){
        setTipoMensagem("warning");
        setMensagem("Aguarde, enviando e-mail...");
      const data = { 
        'destinatario' : email, 
        'assunto' : "Alteração de senha no Sistema de Participação Social das Decisões da ANA",
        'texto' : "",
        'html' : "<p><b>Sistema de Participação nas decisões da ANA</b></p>"+
                 "<br />"+
                 "<p>O n° de confirmação de sua alteração de senha: "+idToken+"</p>"+
                 `Informe este n° de confirmação na página de <a href='https://participacao-social.ana.gov.br/confirma/${idToken}'>confirmação</a> `+
                 " e informe a nova senha.</p>"
       }
       await api.post(
        "/api/sendmail",
        data);
      setAvisoEmail(true);
    }
    
    function hancleConfirmar(){
      history.push(`/Confirma/0`);
    }
    return (
      <>
        <Container>
          <Row>
            <Col sm={12}>
              <div className="voltar">
                <a href={`/Consulta/${idAudiencia}`}>voltar</a>
              </div>
            </Col>
          </Row>
          <form id="formContribuinte">
            <div className={avisoEmail? "quadro naoMostrar":"quadro mostrar"}>
              <Row>
                <Col sm="12">
                  <h3>Alteração de senha</h3>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <label htmlFor="Email">E-mail:*</label>
                </Col>
                <Col sm="10">
                  <input
                    id="Email"
                    className="Requerido"
                    type="email"
                    placeholder="E-mail"
                    onBlur={e => {
                      if (email.length > 0)
                        document.getElementById("Email").className = "Normal";
                      else
                        document.getElementById("Email").className = "Requerido";
                    }}
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                  />
                </Col>
              </Row>
              <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                <Col sm="12">
                  <Alert variant={tipoMensagem}>
                      {mensagem}
                  </Alert>
                </Col>
              </Row>
              <Row>
              <Col sm={12} className="linhaBotao">
                <Button variant="secondary" onClick={handleCancelar}>Cancelar</Button>
                <Button variant="success" onClick={handleAEnviarNovo}>Enviar</Button>
              </Col>
              </Row>
              <Row>
                <Col sm="12" className="observacao">
                  Os itens marcados com <strong>*</strong> (asterisco) são obrigatórios!
                </Col>
              </Row>
            </div>
            <div className={avisoEmail? "quadro mostrar":"quadro naoMostrar"}>
              <Row>
                  <Col sm="12">
                    <b>Alteração de senha:</b><br /><br />
                    Um e-mail com o n° de confirmação da alteração de senha foi enviado para seu endereço de e-mail,<br />
                    utilize este n° para confirmar a inscrição e informar a nova senha.<br />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Button variant="info" onClick={hancleConfirmar}>Confirmar a inscrição</Button>
                  </Col>
                </Row>
            </div>
          </form>
        </Container>
      </>
    );
}